import { render, staticRenderFns } from "./server.vue?vue&type=template&id=723f524e&scoped=true"
import script from "./server.vue?vue&type=script&lang=js"
export * from "./server.vue?vue&type=script&lang=js"
import style0 from "./server.vue?vue&type=style&index=0&id=723f524e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723f524e",
  null
  
)

export default component.exports